import React from 'react';

export default () => (
  <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.4375 1.875H11.25C11.8125 1.875 12.1875 2.25 12.1875 2.8125V3.75H0V2.8125C0 2.25 0.46875 1.875 0.9375 1.875H3.75C3.9375 0.84375 4.96875 0 6.09375 0C7.21875 0 8.25 0.84375 8.4375 1.875ZM4.6875 1.875H7.5C7.3125 1.3125 6.65625 0.9375 6.09375 0.9375C5.53125 0.9375 4.875 1.3125 4.6875 1.875ZM0.9375 4.6875H11.25L10.4063 14.1563C10.4063 14.625 9.9375 15 9.46875 15H2.71875C2.25 15 1.875 14.625 1.78125 14.1563L0.9375 4.6875Z" fill="currentColor" />
  </svg>

);
